import * as React from 'react';
import { SectionBlock } from '../SectionBlock';
import { VerticalSlider } from '../VerticalSlider';
import { Slide } from './internal/components/Slide';

import * as styles from './ApartmentFinishing.css';

type FinishingItem = {
  /** Описание **/
  description?: string | null;
  /** Изображение **/
  image: { url: string };
  /** Название отделки **/
  name: string;
};

type ApartmentFinishingProps = {
  description: string;
  title: string;
  finishing: FinishingItem[];
};

export const ApartmentFinishing: React.FC<ApartmentFinishingProps> = ({ description, title, finishing }) => {
  return (
    <SectionBlock title={title} sectionTabTitle={title} id="apartment-finishing" description={description}>
      <div className={styles['slider']}>
        <VerticalSlider containerClass={styles['slider-list']} arrow={() => null}>
          {finishing.map((item, index) => (
            <Slide
              key={index}
              title={item.name}
              modalTitle={title}
              description={item.description}
              imageUrl={item.image.url}
            />
          ))}
        </VerticalSlider>
      </div>
    </SectionBlock>
  );
};
